<template>


    <!-- preloader start -->
    <div id="pre-load">
        <div id="loader" class="loader">
            <div class="loader-container has-theme-blue">
                <div class="loader-icon"><img src="/assets/images/favicon-blue.png" alt=""></div>
            </div>
        </div>
    </div>
    <!-- preloader end -->

    <!-- preloader start -->

    <div id="rs-mouse">
        <div id="cursor-ball"></div>
    </div>

    <!-- preloader end -->

    <!-- Header area start -->
    <header>
        <div class="rs-header-area rs-header-one has-theme-blue rs-sticky" id="header-sticky">
            <div class="container-fluid g-0">
                    <div class="header-top">
               <div class="row justify-content-center justify-content-lg-between align-items-center gy-2">
                        <div class="col-auto d-none d-lg-block">
                            <div class="header-links">
                                <ul>
<li class="d-none d-xl-inline-block"><i class="bi bi-geo-alt-fill"></i>北京市西城区新街口外大街28号C座302室 </li>
   <li class="d-none d-xl-inline-block">&nbsp; <i class="bi bi-telephone-fill"></i><a href="tel:4006988915">400-6988-915</a></li>                               
                                </ul>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="header-links header-right">
                                <ul>
                                     <li>
 <a href="http://smartsentry.datascore.cn:8100/" class="ptrk" target="_blank"><i class="bi bi-globe"></i>智能哨兵云平台入口</a>
                                    </li>
                                    <li>    
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-header-inner">
                    <div class="rs-header-left">
                        <div class="rs-header-logo-wrapper">
                            <div class="rs-header-logo">
                                <a href="/index"><img src="/assets/images/logo/logo.png" alt="logo"></a>
                            </div>
                        </div>
                    </div>
                    <div class="rs-header-menu">

                        <nav id="mobile-menu" class="main-menu">
                            <ul class="multipage-menu">
                                <li class="menu-item">
                                    <a href="/index">首页</a>

                                </li>
                                <!-- about menu -->
                                <li class="menu-item">
                                    <a href="/products.html">产品中心</a>

                                </li>
                                <!-- page menu -->
                                <li class="menu-item-has-children">
                                    <a href="javascript:void(0)">解决方案</a>
                                    <ul class="submenu last-children">

                                        <li>
                                            <a href="/solution1.html">有限空间作业智能管控方案</a>
                                        </li>

                                        <li>
                                            <a href="/solution2.html">高处作业智能管控方案</a>
                                        </li>

                                    </ul>
                                </li>
                                <!-- elements menu -->
                                <li class="menu-item">
                                    <a href="/case.html">客户案例</a>

                                </li>
                                <li class="menu-item">
                                    <a href="/channelcooperation.html">渠道合作</a>

                                </li>
                                <li class="menu-item">
                                    <a href="/aboutus.html">关于我们</a>

                                </li>
                                <li class="menu-item">
                                    <a href="/resourcecenter">资源中心</a>

                                </li>
                                <li class="menu-item active">
                                    <a href="/news">新闻动态</a>

                                </li>
                                <li class="menu-item">
                                    <a href="/contactus">联系我们</a>

                                </li>


                            </ul>
                        </nav>
                    </div>
                    <div class="rs-header-right">

                        <div class="rs-header-btn">
                            <a class="rs-btn has-theme-blue has-icon has-bg" href="/contactus">立即体验
                                <span class="icon-box">
                                    <svg class="icon-first" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                    <svg class="icon-second" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                        <div class="rs-header-hamburger has-theme-blue">
                            <div class="sidebar-toggle">
                                <a class="bar-icon" href="javascript:void(0)" @click="toggleLayer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                        fill="none">
                                        <path
                                            d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                                            fill="#616161"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- Header area end -->


    <!-- Offcanvas area start -->
    <div class="fix" v-if="isShow">
        <div class="offcanvas-area has-theme-blue info-open" data-lenis-prevent>
            <div class="offcanvas-wrapper">
                <div class="offcanvas-content">
                    <div class="offcanvas-top d-flex justify-content-between align-items-center mb-25">
                        <div class="offcanvas-logo">
                            <a href="/index"><img src="/assets/images/logo/logo.png" alt="logo"></a>
                        </div>
                        <div class="offcanvas-close">
                            <button class="offcanvas-close-icon animation--flip" @click="toggleLayer">
                                <span class="offcanvas-m-lines">
                                    <span class="offcanvas-m-line line--1"></span><span
                                        class="offcanvas-m-line line--2"></span><span
                                        class="offcanvas-m-line line--3"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="offcanvas-about mb-30 d-none d-sm-block">
                        <p>北京大唐思拓信息技术有限公司成立于2006年。自创立之初，我们便坚定地投身于中国的安全生产管理事业。历经近二十年的深耕与发展，我们从最初的安全管理信息化系统研发与服务，逐步成长为今天集深厚行业经验与前沿AI技术于一体的国家级高新技术企业。我们是国内领先的人工智能与物联网（AIoT）解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                        </p>
                    </div>

                    <div class="mobile-menu mean-container">
                        <div class="mean-bar">
                            <nav class="mean-nav">
                                <ul class="multipage-menu">
                                    <li class="menu-item">
                                        <a href="/index">首页</a>

                                    </li>
                                    <!-- about menu -->
                                    <li class="menu-item active">
                                        <a href="/products.html" class="active">产品中心</a>

                                    </li>
                                    <!-- page menu -->
                                    <li class="menu-item">
                                        <a href="javascript:void(0)">解决方案</a>
                                        <ul class="submenu last-children">

                                            <li>
                                                <a href="/solution1.html">有限空间作业智能管控方案</a>
                                            </li>

                                            <li>
                                                <a href="/solution2.html">高处作业智能管控方案</a>
                                            </li>

                                        </ul>
                                        <a class="mean-expand" href="#" style="font-size: 18px"><i
                                                class="fa-regular fa-plus"></i></a>
                                    </li>
                                    <!-- elements menu -->
                                    <li class="menu-item">
                                        <a href="/case.html">客户案例</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="/channelcooperation.html">渠道合作</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="/aboutus.html">关于我们</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="/resourcecenter">资源中心</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="/news">新闻动态</a>

                                    </li>
                                    <li class="menu-item mean-last">
                                        <a href="/contactus">联系我们</a>

                                    </li>


                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="offcanvas-contact mb-30">
                        <h4 class="offcanvas-title-meta">联系我们</h4>
                        <ul>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-geo-alt-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="#">北京市西城区新街口外大街 28号C座 302 室 </a>
                                </div>
                            </li>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-telephone-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="tel:400-6988-915">400-6988-915 </a>
                                </div>
                            </li>

                        </ul>
                    </div>
                    <div class="offcanvas-social">
                        <h4 class="offcanvas-title-meta">关注我们</h4>
                        <ul>
                            <li><a href="/assets/images/weibo.jpg"> <img
                                        src="/assets/images/weibo.jpg"><label>微博</label></a></li>
                            <li><a href="/assets/images/bjh.jpg"><img src="/assets/images/bjh.jpg"><label>百家号</label></a>
                            </li>
                            <li><a href="/assets/images/code.jpg"><img
                                        src="/assets/images/code.jpg"><label>微信公众号</label></a></li>
                            <li><a href="/assets/images/douyin.jpg"><img
                                        src="/assets/images/douyin.jpg"><label>抖音</label></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="offcanvas-overlay overlay-open"></div>
        <div class="offcanvas-overlay-white"></div>
    </div>

    <!-- Offcanvas area start -->

    <!-- Body main wrapper start -->
    <main class="homemain">

        <!-- breadcrumb area start -->
        <section class="rs-breadcrumb-area rs-breadcrumb-one p-relative">
            <div class="rs-breadcrumb-bg" style="background-image: url(/assets/images/bg/breadcrumb-bg-01.png);"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xxl-6 col-xl-8 col-lg-8">
                        <div class="rs-breadcrumb-content-wrapper">
                            <div class="rs-breadcrumb-title-wrapper">
                                <h1 class="rs-breadcrumb-title">新闻动态</h1>
                            </div>
                            <div class="rs-breadcrumb-menu">
                                <nav>
                                    <ul>
                                        <li><span><a href="/index">网站首页</a></span></li>
                                        <li><span>新闻动态</span></li>

                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- breadcrumb area end -->



        <!-- postbox area start -->
        <section class="rs-postbox-area section-space">
            <div class="container">
                <div class="row g-5">
                    <div class="col-xl-4 col-lg-4">
                        <div class="rs-sidebar-wrapper ">

                            <div class="sidebar-widget widget-categories-two mb-30">
                                <h5 class="sidebar-widget-title">新闻分类</h5>
                                <div class="sidebar-widget-content">
                                    <div class="list">
                                        <ul v-for="category in newsCategories" :key="category.level">
                                            <li>
                                                <a href="#" @click="toNews(category.level)"> {{ category.name }}
                                                    <i class="ri-arrow-right-line"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="sidebar-widget mb-30">
                                <h5 class="sidebar-widget-title">热点新闻</h5>
                                <div class="sidebar-widget-content">
                                    <div class="sidebar-blog-item-wrapper" v-for="topNew in hotNewsList"
                                        :key="topNew.id">
                                        <div class="sidebar-blog-item">
                                            <div class="sidebar-blog-thumb">
                                                <a href="#" @click.prevent="goToNewsView(topNew.id)">
                                                    <img :src="`${topNew.cardImage}`" alt="" >
                                                </a>
                                            </div>
                                            <div class="sidebar-blog-content">
                                                <h6 class="sidebar-blog-title">
                                                   {{ topNew.title }}
                                                </h6>
                                                <div class="sidebar-blog-meta">
                                                    <i class="ri-calendar-line"></i>
                                                    <span>{{ topNew.stamp }}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-8">

                        <div class="rs-postbox-details-wrapper">
                            <div class="rs-postbox-content">
                                <div class="rs-postbox-meta-list">
                                    <div class="rs-postbox-meta-item">
                                        <span class="rs-meta-text"><a class="meta-author" href="blog-details.html">
                                                {{ model.publisher }}</a></span>
                                    </div>
                                    <div class="rs-postbox-meta-item">
                                        <span class="rs-postbox-meta-text">{{ model.stamp }}</span>
                                    </div>
                                </div>
                                <h3 class="rs-postbox-details-title">
                                    {{ model.title }}
                                </h3>
                            </div>
                            <div class="rs-postbox-details-thumb">
                                <!-- <img src="assets/images/blog/details/blog-details-01.png" alt="image"> -->
                                <img :src="`${model.cardImage}`" alt="" >
                            </div>
                            <div class="rs-postbox-details-content">
                                <div v-html="model.content"></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
        <!-- rs-postbox area end -->






    </main>
    <!-- Body main wrapper end -->
    <div class="rs-footer-bg-thumb-wrapper">
        <div class="rs-footer-bg-thumb" data-background="assets/images/bg/footer-bg-02.png"></div>



        <!-- Body main wrapper end -->

        <!-- footer area start -->
        <footer>
            <div class="rs-footer-area rs-footer-two has-theme-blue">
                <div class="container">
                    <div class="rs-footer-top">
                        <div class="row g-5">
                            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-1">
                                    <h5 class="rs-footer-widget-title">关于我们</h5>
                                    <div class="rs-footer-widget-content">
                                        <img src="/assets/images/logo/logo1.png" style="height: 60px;" alt="">
                                        <p class="rs-footer-widget-description">
                                            智能守护安全，创新引领未来，20年的深耕与发展，领先的人工智能与物联网(AIoT)解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-2">
                                    <h5 class="rs-footer-widget-title">产品与服务</h5>
                                    <div class="rs-footer-widget-content">
                                        <div class="rs-footer-widget-links has-theme-blue">
                                            <ul>
                                                <li> <a href="/products.html">产品中心</a> </li>
                                                <li><a href="/solution1.html">解决方案</a></li>
                                                <li><a href="/case.html">客户案例</a></li>
                                                <li><a href="/channelcooperation.html">寻求合作</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <h5 class="rs-footer-widget-title">支持与资源</h5>
                                <div class="rs-footer-widget-content">
                                    <div class="rs-footer-widget-links has-theme-blue">
                                        <ul>

                                            <li> <a href="/news">新闻中心</a> </li>
                                            <li><a href="/resourcecenter">获取资源</a></li>
                                            <li><a href="/contactus">联系我们</a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-6">
                                <div class="rs-footer-widget">
                                    <h5 class="rs-footer-widget-title">关注我们</h5>
                                    <div class="rs-footer-widget-content">

                                        <p class="rs-footer-widget-description" style="margin-bottom: 10px;">
                                            关注我们的社交媒体了解更多信息
                                        </p>
                                        <div class="rs-footer-widget-social">
                                            <div class="rs-theme-social has-theme-blue">
                                                <a href="/assets/images/weibo.jpg"> <img
                                                        src="/assets/images/weibo.jpg"><label>微博</label></a>
                                                <a href="/assets/images/bjh.jpg"><img
                                                        src="/assets/images/bjh.jpg"><label>百家号</label></a>
                                                <a href="/assets/images/code.jpg"><img
                                                        src="/assets/images/code.jpg"><label>微信公众号</label></a>
                                                <a href="/assets/images/douyin.jpg"><img
                                                        src="/assets/images/douyin.jpg"><label>抖音</label></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-footer-copyright-area rs-copyright-one">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-8">
                                <div class="rs-footer-copyright has-theme-blue text-left">
                                    <p class="underline"> 版权所有 © <span id="year">2025</span> <a
                                            href="http://www.datascore.com" target="_blank">北京大唐思拓信息技术有限公司</a></p>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div style="text-align: right; color: #fff;"> <a href="https://beian.miit.gov.cn/"
                                        target="_blank">京ICP备19044307号</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- footer area end -->

    </div>


    <!-- back to top -->
    <!-- Backtotop start -->
    <div class="backtotop-wrap cursor-pointer" @click="scrollToTop">
        <svg class="backtotop-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>

</template>

<script setup>
import { ref, shallowRef, onMounted, onUnmounted, reactive, watch } from 'vue';
import http from '@/shared/http.service';
import { Uris, } from '@/shared/const';
import { Subject, } from 'rxjs';
import { catchError, switchMap, } from 'rxjs/operators';
import dayjs from 'dayjs';

import { useRoute, useRouter } from 'vue-router';
onMounted(() => {
 
  
});

const isActive = ref(false);
const route = useRoute();
const router = useRouter();
const query = new URLSearchParams(window.location.search);
const newsId = route.params.id;//query.get('id');//route.params.id; 
const model = reactive({
    title: "",
    content: "",
    stamp: null,
    publisher: "",
    intro: "",
    pageTopics:"",
    cardImage: "",
});
const hotNewsList = ref([]); // 热点新闻列表 

// 响应式变量：控制隐藏层显示状态（默认隐藏）
const isShow = ref(false);
// 滚动到顶端的方法
const scrollToTop = () => {
    // 方法1：使用 window.scrollTo() 带平滑动画
    window.scrollTo({
        top: 0, // 滚动到顶部
        behavior: 'smooth' // 平滑滚动（关键）
    });

    // 方法2：兼容旧浏览器（手动设置滚动距离，无动画）
    // document.documentElement.scrollTop = 0
    // document.body.scrollTop = 0
};
// 切换显示状态的方法
const toggleLayer = () => {
    isShow.value = !isShow.value;
};

// 动态设置页面标题和 description
const setPageMeta = (title, desc) => {
  document.title = title;
  
  // 更新或创建 description meta 标签
  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) {
    metaDesc = document.createElement('meta');
    metaDesc.name = 'description';
    document.head.appendChild(metaDesc);
  }
  metaDesc.setAttribute('content', desc);
};

//////////////////
// window.scrollTo(0, 0)
onMounted(async() => {
  await  fetchNewsCategories();
  await  getHotNewsList();
  await getNewDetail(newsId); // ✅ 真正等待数据加载完成

 
});


const goToNewsView = (id) => {
    console.log(id);
    // 使用路由跳转更新URL
    router.push({
        path: route.path,
        query: { id }
    });
};



const toNews = (level) => {
    window.open(`/news?level=${level}`, '_blank');
};

const newsCategories = ref([]); // 存储新闻分类数据
const newsList = ref([]); // 当前分类下的新闻列表 
const activeCategory = ref(null); // 当前选中的分类 ID

// 获取新闻分类
const fetchNewsCategories = async () => {
    try {
        const response = await http.post(Uris.NewsCategoryList, { isOnlyParent: 1 }).subscribe(t => {
            const { list, totalCount, totalPageCount, pageIndex, pageSize } = t;
            newsCategories.value = list;
            if (newsCategories.value.length > 0) {
                activeCategory.value = newsCategories.value[0].level; // 默认选中第一个分类
            }
        }); // 调用后台接口


    } catch (error) {
        console.error('获取新闻分类失败:', error);
    }
};


// 获取热点新闻列表
const getHotNewsList = async () => {
    // 由于新闻列表是push添加的，每次切换分类都需要先清空列表
    hotNewsList.value = [];
    try {
        const response = await http.get(Uris.List, {
            pageIndex: 1, pageSize: 4, isFront: 1
        }).subscribe(t => {
            const { list, totalCount, totalPageCount, pageIndex, pageSize } = t;
            t.list.forEach(element => {
                const model = {
                    id: element.id,
                    title: element.title,
                    month: dayjs(element.stamp).format('MM'),
                    day: dayjs(element.stamp).format('DD'),
                    stamp: dayjs(element.stamp).format('YYYY-MM-DD HH:mm'),
                    intro: element.intro,
                    pageTopics:element.pageTopics,
                    publisher: element.publisher,
                    cardImage: `${window.serverConfig.baseUrl}/${element.cardImage}`,
                };
                hotNewsList.value.push(model);
            });

        });

    } catch (error) {
        console.error('获取新闻列表失败:', error);
    }
};

const getNewDetail = (id) => {
  http.get(Uris.Get, { articleId: id, isFront: 1 })
    .subscribe({
      next: (result) => {
        if (result) {
         model.title = result.title;
        model.content = result.content;
        model.stamp = result.stamp;
        model.publisher = result.publisher;
        model.intro = result.intro;
        model.pageTopics = result.pageTopics;
        model.cardImage = `${window.serverConfig.baseUrl}/${result.cardImage}`;

          // ✅ 在这里设置 meta！
          setPageMeta(
            model.title || '新闻详情',
            model.pageTopics || '查看详情'
          );
        }
      },
      error: (err) => {
        console.error('获取新闻详情失败:', err);
      }
    });
};

onUnmounted(() => {
    // detailSubscription.unsubscribe();
});
</script>